"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customStyles = exports.selectThemeStyles = void 0;
var index_1 = require("../theme/index");
var colors = index_1.theme.colors;
var selectThemeStyles = function () {
    return {
        borderRadius: 4,
    };
};
exports.selectThemeStyles = selectThemeStyles;
exports.customStyles = {
    container: function (provided) { return (__assign(__assign({}, provided), { boxShadow: 'none' })); },
    control: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: 4, boxShadow: 'none', backgroundColor: state.isFocused ? colors.Hannibal[100] : colors.Grey[0], borderColor: state.isFocused
            ? colors.Hannibal[600]
            : state.isDisabled
                ? colors.Grey[400]
                : colors.Grey[500], color: state.isDisabled ? colors.Grey[400] : colors.Grey[900], '&:focus, &:hover': {
            borderColor: colors.Hannibal[600],
        }, '&:focus': {
            backgroundColor: colors.Hannibal[100],
        } })); },
    input: function (provided) { return (__assign(__assign({}, provided), { display: 'flex', flex: 1, textOverflow: 'ellipsis', '&:after': {
            content: 'none',
        }, '& input': {
            flex: 1,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        } })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { fontSize: 14 })); },
    placeholder: function (provided, state) { return (__assign(__assign({}, provided), { position: 'absolute', whiteSpace: 'nowrap', fontSize: 14, color: state.isDisabled ? colors.Grey[400] : colors.Grey[900] })); },
    menu: function (provided) { return (__assign(__assign({}, provided), { boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)" })); },
    menuList: function (provided) { return (__assign(__assign({}, provided), { padding: 6, border: 'none', transform: 'scale(1)' })); },
    option: function (provided, state) { return (__assign(__assign(__assign(__assign({}, provided), { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', cursor: 'pointer', borderRadius: 4, padding: '10px 10px', '&:hover': {
            background: colors.Grey[100],
        } }), (state.isSelected && {
        background: colors.Hannibal[100],
        color: colors.Hannibal[600],
    })), (state.isFocused && {
        background: colors.Grey[100],
    }))); },
    multiValue: function (provided) { return (__assign(__assign({}, provided), { borderRadius: 100, padding: '0px 6px', margin: 3, marginRight: 5 })); },
    multiValueRemove: function (provided) { return (__assign(__assign({}, provided), { '&:hover': {
            backgroundColor: 'unset',
            color: 'unset',
        } })); },
    valueContainer: function (provided) { return (__assign(__assign({}, provided), { minHeight: 38, padding: '5px 8px 5px' })); },
    indicatorsContainer: function (provided, state) { return (__assign(__assign({}, provided), (state.selectProps.menuIsOpen && {
        transform: 'scaleY(-1)',
    }))); },
};
//# sourceMappingURL=styles.js.map